export const LOCALE = 'pt-BR'

export const COLLATOR = new Intl.Collator(LOCALE)
